module.exports = __webpack_public_path__ + "img/syukyaku-top-ira001.6f650a0c.png";